/*
 * @描述:接口文件
 * @版本: 1.0
 * @作者: 冯强
 * @创建时间: 2022-11-23 17:35:18
 */
import { post } from './request'

const HOST = BASEURL
const HOSTSL = BASESLURL


//账号密码登录
export const AccountLogin = data => post(HOST + '/admin/web/login', data)

//获取菜单列表
export const ReqMenuList = data => post(HOST + '/admin/web/treenode/list', data)

//新增菜单
export const AddMenu = data => post(HOST + '/admin/web/treenode/add', data)

//删除菜单
export const DelMenu = data => post(HOST + '/admin/web/treenode/del', data)

//编辑菜单
export const EditMenu = data => post(HOST + '/admin/web/treenode/edit', data)

export const treeNodeEdit = data => post(HOST + '/admin/web/treenode/nodeEdit', data)

//菜单详情
export const MenuDetail = data => post(HOST + '/admin/web/treenode/details', data)

//菜单 --- 功能点列表
export const MenuFuncPointList = data => post(HOST + '/admin/web/treenode/funcPointList', data)

//菜单 --- 功能点新增/编辑
export const MenuFuncPointEdit = data => post(HOST + '/admin/web/treenode/funcPointEdit', data)

//菜单 --- 功能点删除
export const MenuFuncPointDel = data => post(HOST + '/admin/web/treenode/funcPointDel', data)

//菜单 --- 功能点批量删除
export const MenuFuncPointBatchDel = data => post(HOST + '/admin/web/treenode/pointBatchDel', data)

//菜单 --- 功能点编辑排序
export const treeNodeEditSort = data => post(HOST + '/admin/web/treenode/editSort', data)

//公司列表
export const ReqCompanyList = data => post(HOST + '/admin/web/company/list', data)

//公司新增
export const AddCompany = data => post(HOST + '/admin/web/company/add', data)

//公司删除
export const DelCompany = data => post(HOST + '/admin/web/company/del', data)

//公司编辑
export const EditCompany = data => post(HOST + '/admin/web/company/edit', data)

//获取公司详情
export const CompanyDetail = data => post(HOST + '/admin/web/company/details', data)

//公司小程序新增
export const StoreWxappAdd = data => post(HOST + '/admin/web/storeWxapp/add', data)

//公司小程序编辑
export const StoreWxappEdit = data => post(HOST + '/admin/web/storeWxapp/edit', data)

//公司小程序详情
export const StoreWxappDetails = data => post(HOST + '/admin/web/storeWxapp/details', data)

// 公司用户列表人员查询
export const CompanyUserList = data => post(HOST + '/admin/web/user/list', data)

// 公司用户列表人员查询（管理员角色）
export const CompanyRoleList = data => post(HOST + '/admin/web/user/roleList', data)

//公司公众号新增
export const accountAdd = data => post(HOST + '/admin/web/account/add', data)

//公司公众号编辑
export const accountEdit = data => post(HOST + '/admin/web/account/edit', data)

//公司公众号详情
export const accountDetails = data => post(HOST + '/admin/web/account/details', data)

//公司公众号删除
export const accountDel = data => post(HOST + '/admin/web/account/del', data)

//获取权限节点
export const getRoleNode = data => post(HOST + '/admin/web/role/getNode', data)

//角色授权
export const rolesAuthorize = data => post(HOST + '/admin/web/role/rolesAuthorize', data)

//预约列表
export const appointList = data => post(HOST + '/admin/web/appoint/list', data)

//预约备注
export const appointEdit = data => post(HOST + '/admin/web/appoint/edit', data)
//获取版本列表
export const getVersions = data => post(HOST + '/admin/web/version/list', data)

//删除版本
export const delVersion = data => post(HOST + '/admin/web/version/del', data)

//获取版本详情
export const getVersionDetails = data => post(HOST + '/admin/web/version/details', data)

//新增版本
export const addVersion = data => post(HOST + '/admin/web/version/add', data)

//编辑版本
export const editVersion = data => post(HOST + '/admin/web/version/edit', data)


//公司认证详情
export const authDetails = data => post(HOST + '/admin/web/company/authDetails', data)

//公司认证审核
export const authAudit = data => post(HOST + '/admin/web/company/authAudit', data)


//编辑系统更新文案
export const addUpgrade = data => post(HOST + '/admin/web/upgrade/add', data)

//获取系统更新文案
export const getUpgrade = data => post(HOST + '/admin/web/upgrade/get', data)

//获取电费用户
export const get798User = data => post(HOST + '/admin/web/user/get798User', data)

//删除电费用户
export const del798User = data => post(HOST + '/admin/web/user/del798User', data)

//保存电费用户
export const save798User = data => post(HOST + '/admin/web/user/save798User', data)

//798展项新增
export const exhibitionProjectAdd = data => post(HOSTSL + '/api/Exhibition/projectAdd', data)

//798展项列表
export const exhibitionProjectList = data => post(HOSTSL + '/api/Exhibition/projectList', data)

//798展项删除
export const exhibitionProjectDel = data => post(HOSTSL + '/api/Exhibition/projectDel', data)

//798展项详情
export const exhibitionProjectDetail = data => post(HOSTSL + '/api/Exhibition/projectDetail', data)

//798展项删除
export const exhibitionProjectEdit = data => post(HOSTSL + '/api/Exhibition/projectEdit', data)

//798展项排序
export const exhibitionProjectSort = data => post(HOSTSL + '/api/Exhibition/projectSort', data)

// 展项分类列表
export const exhibitionCategoryList = data => post(HOSTSL + '/api/Exhibition/categoryList', data)

// 展项分类新增
export const exhibitionCategoryAdd = data => post(HOSTSL + '/api/Exhibition/categoryAdd', data)

// 展项分类编辑
export const exhibitionCategoryEdit = data => post(HOSTSL + '/api/Exhibition/categoryEdit', data)

// 展项分类删除
export const exhibitionCategoryDel = data => post(HOSTSL + '/api/Exhibition/categoryDel', data)

// 展项分类排序
export const exhibitionCategorySort = data => post(HOSTSL + '/api/Exhibition/categorySort', data)

// 展厅新增
export const exhibitionHallAdd = data => post(HOSTSL + '/api/Exhibition/hallAdd', data)

// 展厅列表
export const exhibitionHallList = data => post(HOSTSL + '/api/Exhibition/hallList', data)

// 展厅编辑
export const exhibitionHallEdit = data => post(HOSTSL + '/api/Exhibition/hallEdit', data)

// 展厅删除
export const exhibitionHallDel = data => post(HOSTSL + '/api/Exhibition/hallDel', data)

// 获取导览首页
export const exhibitionHallMap = data => post(HOSTSL + '/api/Exhibition/hallMap', data)

// 编辑导览首页
export const exhibitionHallMapEdit = data => post(HOSTSL + '/api/Exhibition/hallMapEdit', data)
